module.exports = __webpack_public_path__ + "static/media/Letra_Caixa (5).42c6b80a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Letra_Caixa/Letra_Caixa (5).jpg
// module id = 344
// module chunks = 0